"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const provider_components_1 = require("@kyruus/provider-components");
const react_1 = require("@xstate/react");
const prop_types_1 = require("prop-types");
const react_2 = __importDefault(require("react"));
const xstate_1 = require("xstate");
const useHeaderHeight_1 = __importDefault(require("../../hooks/useHeaderHeight"));
const configUtils_1 = require("../../lib/configUtils");
const utils_directBook_1 = require("../DirectBook/utils.directBook");
const AltProviders_1 = __importDefault(require("./AltProviders"));
const CareTeamsProviders_1 = __importDefault(require("./CareTeamsProviders"));
const styles_1 = require("./styles");
const proptypes = {
    /** The appointment query to display purpose and relationship, as well as visit-type related things */
    appointmentQuery: (0, prop_types_1.shape)({
        patientRel: prop_types_1.string,
        purpose: (0, prop_types_1.shape)({
            name: prop_types_1.string,
            visit_method: prop_types_1.string
        })
    }).isRequired,
    /** The config object for the customer */
    config: prop_types_1.object.isRequired,
    /** Boolean for whether the alt providers should be shown */
    showAltProvidersOnStep2: prop_types_1.bool.isRequired,
    /** The provider to display in the sidebar */
    provider: prop_types_1.object.isRequired,
    /** The appointment slots to display time data for */
    selectedAppointment: prop_types_1.object.isRequired,
    /** The state machine of the current page  */
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    /** Tracking function */
    track: prop_types_1.func.isRequired
};
function Sidebar({ appointmentQuery, config, showAltProvidersOnStep2, provider, selectedAppointment, service, track }) {
    const [state] = (0, react_1.useService)(service);
    const { altProviders, careTeamsProviders, services, featureFlags, shouldShowCareTeamsInSidebar } = state.context;
    const [headerHeight] = (0, useHeaderHeight_1.default)();
    // Use computed property from state machine instead of component-level logic
    const showCareTeams = shouldShowCareTeamsInSidebar;
    const showSchedulingHelpBanner = !(0, configUtils_1.shouldHideSchedulingHelpMessages)(config);
    if (!provider) {
        return null;
    }
    // Determine the position of care teams above and below alt providers based on feature flags
    const isReversed = (0, utils_directBook_1.shouldShowCareTeamsBelowAltProviders)(featureFlags);
    const providerSections = [
        showCareTeams && services && (react_2.default.createElement(CareTeamsProviders_1.default, { key: "care-teams", config: config, careTeamsProviders: careTeamsProviders, services: services, track: track })),
        showAltProvidersOnStep2 && services && (react_2.default.createElement(AltProviders_1.default, { key: "alt-providers", config: config, altProviders: altProviders, services: services, track: track }))
    ].filter(Boolean);
    return (react_2.default.createElement(styles_1.SidebarContainer, null,
        react_2.default.createElement(styles_1.SidebarContent, { headerHeight: headerHeight },
            react_2.default.createElement(provider_components_1.ProviderSidebar, { appointmentQuery: appointmentQuery, locations: provider && provider.locations, selectedAppointment: selectedAppointment, provider: provider, showApptTime: true, showSchedulingHelpBanner: showSchedulingHelpBanner }),
            react_2.default.createElement(styles_1.StyledProvidersWrapper, null, isReversed ? providerSections.reverse() : providerSections))));
}
Sidebar.propTypes = proptypes;
exports.default = Sidebar;
//# sourceMappingURL=Sidebar.js.map